import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { SingleAccountProps, SingleAccount } from './single-account';

export interface SingleBankProps {
  id: number;
  name: string;
  account: SingleAccountProps[];
}

export const SingleBank = types.model({
  id: types.number,
  name: types.string,
  account: types.optional(types.array(SingleAccount), []),
});

export type SingleBankSnapshot = SnapshotIn<typeof SingleBank>;
export type SingleBankInstance = Instance<typeof SingleBank>;
